<template>
  <div>
    <div class="item" v-for="item in list">
      <el-select
          v-model="item.partner_id"
          placeholder="请选择"
          clearable
          style="width:200px">
        <el-option
          v-for="(item,index) in partnerList"
          :key="index"
          :label="item.title"
          :value="item.id">
        </el-option>
      </el-select>

      <el-date-picker value-format="yyyy-MM-dd" v-model="item.vip_start_at" placeholder="选择时间" style="width: 200px"></el-date-picker>

      <el-date-picker value-format="yyyy-MM-dd" v-model="item.vip_end_at" placeholder="选择时间" style="width: 200px"></el-date-picker>

      <!-- <a class="link-btn" @click="addItem(index)">添加</a> -->
      <a class="link-btn" @click="deleteItem(index)">删除</a>

    </div>

    <el-button size="small" type="primary" @click="addItem(0)">添加一组</el-button>

    <div class="footer">
      <!-- <el-button @click="isShowSetting = false">取 消</el-button> -->
      <el-button style="float:right" type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'VipSetting',
  props: {
    uuid: {
      type: String
    },
    value: {
      type: Array
    }
  },
  data () {
    return {
        list: [],
        partnerList: []
    }
  },
  mounted () {
    request({
      url: `/partners`
    }).then(res => {
      this.partnerList = res.data.list
    })

    request({
        url: `/users/${this.uuid}/partner-vip-records`
      }).then(res => {
        this.list = res.data.list
      })
  },
  watch: {
    uuid (val) {
      request({
        url: `/users/${this.uuid}/partner-vip-records`
      }).then(res => {
        this.list = res.data.list
      })
    },
    value (val) {
      this.list = val
    }
  },
  methods: {
    submit () {
      request({
        url: `/users/${this.uuid}/partner-vip-records`,
        method: 'put',
        data: {
          list: this.list
        }
      }).then(res => {
        this.$message.success('设置成功!')
        this.$emit('close')
      })
    },
    deleteItem (index) {
      this.list.splice(index, 1)
    },
    addItem (index) {
      index = this.list.length
      index = index < 0 ? 0 : index
      this.list.splice(index, 0 , {
        partner_id: null,
        vip_start_at: '',
        vip_end_at: ''
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
    width: 800px;
}

.item {
  margin-bottom: 10px;
}

.link-btn {
  color: blue;
  cursor: pointer;
}

.footer {
  margin-top: 30px;
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/partnerVips.vue